import React, { Fragment } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, MobileStepper } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

const useStyles = makeStyles(theme => ({
  stepperContentWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  nextButton: {
    display: 'flex',
    marginLeft: 'auto'
  },
  button: {
    minWidth: theme.spacing(2),
    maxWidth: theme.spacing(2),
    height: theme.spacing(5),
    boxShadow: '0px 0px 6px #00000029',
    padding: 0
  },
  stepperContent: {
    color: '#43425D',
    fontSize: 15,
    padding: theme.spacing(2)
  },
  mobileStepper: {
    backgroundColor: theme.palette.secondary.main,
    color: '#43425D',
    justifyContent: 'center'
  }
}));

const Announcements = props => {
  const classes = useStyles();
  const { list, stepperContent = () => {} } = props;
  const [ activeStep, setActiveStep ] = React.useState(0);
  const maxSteps = list.length;

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };
  return (
    <Fragment>
      <Box className={classes.stepperContentWrapper}>
        <Button className={classes.button} size="small" onClick={handleBack} disabled={activeStep === 0}>
          <KeyboardArrowLeft color={activeStep === 0 ? 'disabled' : 'primary'} />
        </Button>
        <Box className={classes.stepperContent}>{stepperContent(list[activeStep])}</Box>
        <Button
          className={clsx(classes.button, classes.nextButton)}
          size="small"
          onClick={handleNext}
          disabled={activeStep === maxSteps - 1}
        >
          <KeyboardArrowRight color={activeStep === maxSteps - 1 ? 'disabled' : 'primary'} />
        </Button>
      </Box>
      <MobileStepper
        variant="dots"
        steps={maxSteps}
        position="static"
        className={classes.mobileStepper}
        activeStep={activeStep}
        nextButton={<Fragment />}
        backButton={<Fragment />}
      />
    </Fragment>
  );
};

export default Announcements;
